import {Observable} from 'rxjs/Observable';

import { CompleterItem } from '../components/completer-item.component';

export interface CompleterData extends Observable<CompleterItem[]> {
  search(term: string): void;
  cancel(): void;
  convertToItem?(data: any): CompleterItem;
};



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/autocomplete/services/completer-data.service.ts